import { registerLicense } from '@syncfusion/ej2-base';

const licenseKey = (window as unknown as { APP_CONFIG?: { syncfusionLicenseKey?: string } }).APP_CONFIG?.syncfusionLicenseKey;

if (licenseKey && licenseKey.trim().length > 0) {
  registerLicense(licenseKey);
} else {
  console.error('Syncfusion license key missing from window.APP_CONFIG');
}
